<template>
  <div></div>
</template>

<script setup lang="ts">
import { addWhatsappButton } from './addWhatsappButton';

addWhatsappButton();
</script>
